import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import * as classes from '../../../../components/BobActionMenu.module.css';

const ClientActionMenu = ({
    history,
    ...props
}) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const handleCreateClient = client => {
        const path = '/v2/dashboard/core/entities/manage';

        const queryValues = queryString.parse(history.location.search);
        queryValues.entityType = 'client';

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
    };

    const renderMenu = () => {
        return <Paper className={classes.BobActionMenu}>
            <Button
                onClick={() => handleCreateClient()}
            >
                <span className="material-icons-outlined md-18">
                    add
                </span>
                <span className={classes.MenuItemText}>Add New Client</span>
            </Button>
        </Paper>;
    };

    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div>
                <React.Fragment>
                    <Button
                        onClick={handleToggle}
                        className={menuOpen ? classes.BobActionButtonActive : classes.BobActionButton}
                    >
                        Actions
                        <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                    </Button>
                    {menuOpen ? renderMenu() : null}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default withRouter(ClientActionMenu);
